export function compareKey(a, b) {
    if (a === b)
        return true;
    if (!a)
        return false;
    if (!b)
        return false;
    return a.ex === b.ex && a.sym === b.sym;
}
export function stringifyKey(key) {
    if (!key)
        return '';
    const str = `${key.sym}:${key.ex}`;
    return str;
}
export function parseKey(keyStr) {
    const lastColon = keyStr.lastIndexOf(':');
    if (lastColon === -1)
        throw new Error('Missing colon delimiter between sym and ex in key.');
    const sym = keyStr.slice(0, lastColon);
    const ex = keyStr.slice(lastColon + 1);
    // const [sym, exPart] = keyStr.split(':');
    return { sym, ex };
}
//# sourceMappingURL=keys.js.map